import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "../../../ui/Modal";
import { connect, useDispatch } from "react-redux";
import ReactSpinner from "react-spinjs-fix";
import {
  questionModalVisibleHandler,
  getQuestionList,
  setFormTextAreaValue,
} from "../../../../actions/chartSideMedicalFillInFormActions";
let timeOut;

const enhancer = connect(
  ({ chartSideMedicalFillInForm: { questionList, questionListFetching, formTextAreaValue } }) => ({
    questionList,
    questionListFetching,
    formTextAreaValue,
  }),
);

function MedicalFillInFormQuestionModal({
  questionList,
  questionListFetching,
  form,
  questionId,
  formTextAreaValue,
}) {
  const [question, setQuestion] = useState("");
  const dispatch = useDispatch();
  const item = form.questions.find((item) => item.id === questionId);

  const initialValue = useMemo(() => (item?.answer || item?.defaultAnswer) && formTextAreaValue, [
    item,
    formTextAreaValue,
  ]);

  useEffect(() => {
    dispatch(getQuestionList({ load: false, question }));
  }, []);

  const trimText = (text) => {
    if (text.length && text.length > 140) return `${text.slice(0, 140)}...`;
    return text;
  };

  const loadList = (e) => {
    const scrollBottom = e.target.scrollTop + e.target.offsetHeight + 1 >= e.target.scrollHeight;
    if (scrollBottom) {
      const data = {
        load: true,
        question: question,
      };
      dispatch(getQuestionList(data));
    }
  };

  const handleChange = (value) => {
    clearTimeout(timeOut);
    setQuestion(value);
    if (!value) {
      return dispatch(getQuestionList({ load: false, filterKey: value, start: 0 }));
    }
    timeOut = setTimeout(() => {
      const data = {
        load: false,
        filterKey: value,
        start: 0,
      };
      dispatch(getQuestionList(data));
    }, 500);
  };

  return (
    <Modal
      title={
        <div className="d-flex align-items-center justify-content-center">
          <div>List of default answers</div>
        </div>
      }
      actions={
        <button className="btn btn-default" onClick={() => dispatch(questionModalVisibleHandler())}>
          close
        </button>
      }
      show={true}
      size="lg"
    >
      <>
        <div className="pr-4 pl-4">
          <form>
            <div>
              <label>
                Question name:
                <input
                  className="form-control"
                  value={question}
                  onChange={({ target }) => handleChange(target.value)}
                />
              </label>
            </div>
          </form>
        </div>
        <div className="p-4">
          <div className="row mb-3" style={{ borderBottom: "1px solid #e5e5e5" }}>
            <div className="col-sm-3">Question name</div>
            <div className="col-sm-7">Default answer text</div>
            <div className="col-sm-2">Action</div>
          </div>
          <div
            style={{
              height: "60vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
            onScroll={loadList}
          >
            {questionListFetching && <ReactSpinner />}
            {!questionList.length && <h4>No results</h4>}
            {(questionList || []).map((question, idx) => {
              return (
                <div
                  key={idx}
                  className="row mb-4 pb-4"
                  style={{ borderBottom: "1px solid #e5e5e5" }}
                >
                  <div className="col-sm-3">{question.question}</div>
                  <div
                    title={question.defaultAnswer}
                    style={{ cursor: "help" }}
                    className="col-sm-7"
                  >
                    {trimText(question.defaultAnswer)}
                  </div>
                  <div className="col-sm-2">
                    <button
                      onClick={() => {
                        dispatch(questionModalVisibleHandler());
                        dispatch(
                          setFormTextAreaValue(`${initialValue || ""} ${question.defaultAnswer}`),
                        );
                      }}
                      className="btn btn-primary"
                    >
                      Select
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </>
    </Modal>
  );
}

export default enhancer(MedicalFillInFormQuestionModal);
